import { render, staticRenderFns } from "./waterMark.vue?vue&type=template&id=871427e0&scoped=true"
import script from "./waterMark.vue?vue&type=script&lang=js"
export * from "./waterMark.vue?vue&type=script&lang=js"
import style0 from "./waterMark.vue?vue&type=style&index=0&id=871427e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871427e0",
  null
  
)

export default component.exports